import Vue from 'vue'

function getClientX (event) {
  if (event.clientX !== undefined) return event.clientX
  if (event.touches && event.touches[0] && event.touches[0].clientX !== undefined) {
    return event.touches[0].clientX
  }
  return 0
}

function getClientY (event) {
  if (event.clientY !== undefined) return event.clientY
  if (event.touches && event.touches[0] && event.touches[0].clientY !== undefined) {
    return event.touches[0].clientY
  }
  return 0
}

Vue.directive('long-press', {
  bind (el, binding, vnode) {
    if (typeof binding.value !== 'function') {
      console.warn('[long-press] مقدار باید تابع باشد')
      return
    }

    let pressTimer = null
    let startX = 0
    let startY = 0
    let isLongPressTriggered = false
    let isWaitingForLongPress = false
    let hasMovedSignificantly = false

    const duration = binding.arg ? parseInt(binding.arg, 10) : 800


    // ========== disable select text ==========
    // disable select text in element and its children
    const originalUserSelect = el.style.userSelect
    const originalWebkitUserSelect = el.style.webkitUserSelect
    const originalWebkitTouchCallout = el.style.webkitTouchCallout

    el.style.userSelect = 'none'
    el.style.webkitUserSelect = 'none'
    el.style.webkitTouchCallout = 'none'

    // disable event selectstart
    const onSelectStart = (e) => {
      if (isWaitingForLongPress || isLongPressTriggered) {
        e.preventDefault()
        e.stopPropagation()
        return false
      }
    }

    // disable copy while long press
    const onCopy = (e) => {
      if (isLongPressTriggered) {
        e.preventDefault()
        e.stopPropagation()
        return false
      }
    }
    // =========================================

    const cancelPress = () => {
      if (pressTimer) {
        clearTimeout(pressTimer)
        pressTimer = null
      }
      isWaitingForLongPress = false
    }

    const onContextMenu = (e) => {
      e.preventDefault()
      e.stopPropagation()
      return false
    }

    const onTouchStart = (e) => {
      if (isWaitingForLongPress) return

      // save start coordinate
      startX = getClientX(e)
      startY = getClientY(e)
      isLongPressTriggered = false
      isWaitingForLongPress = true
      hasMovedSignificantly = false

      // set timer of long press
      pressTimer = setTimeout(() => {
        if (isWaitingForLongPress && !isLongPressTriggered && !hasMovedSignificantly) {
          isLongPressTriggered = true
          isWaitingForLongPress = false

          // stop & prevent next actions if long press is active
          e.preventDefault()
          e.stopPropagation()

          // stop & prevent next clicks
          const preventClick = (clickEvent) => {
            clickEvent.preventDefault()
            clickEvent.stopPropagation()
            document.removeEventListener('click', preventClick, true)
          }
          document.addEventListener('click', preventClick, true)

          // run user function
          binding.value(e, el, { duration })

          // vibrate user device
          if (window.navigator && window.navigator.vibrate) {
            window.navigator.vibrate(50)
          } else if (window.navigator && window.navigator.webkitVibrate) {
            window.navigator.webkitVibrate(50)
          }

          cancelPress()
        }
      }, duration)
    }

    const onTouchMove = (e) => {
      if (!isWaitingForLongPress || isLongPressTriggered) return

      const currentX = getClientX(e)
      const currentY = getClientY(e)
      const moveX = Math.abs(currentX - startX)
      const moveY = Math.abs(currentY - startY)

      // cancel long press if move more than limit
      if (moveX > 10 || moveY > 10) {
        hasMovedSignificantly = true
        cancelPress()
      }
    }

    const onTouchEnd = (e) => {
      // stop & prevent next clicks if long press is active
      if (isLongPressTriggered) {
        e.preventDefault()
        e.stopPropagation()
      }
      // else, run click event
      cancelPress()
    }

    const onTouchCancel = () => {
      cancelPress()
    }

    // check device is touch
    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0

    if (isTouchDevice) {
      el.addEventListener('touchstart', onTouchStart, { passive: false })
      el.addEventListener('touchmove', onTouchMove, { passive: false })
      el.addEventListener('touchend', onTouchEnd)
      el.addEventListener('touchcancel', onTouchCancel)
    } else {
      // use mouse event for desktops
      const onMouseDown = (e) => {
        startX = getClientX(e)
        startY = getClientY(e)
        isWaitingForLongPress = true
        isLongPressTriggered = false
        hasMovedSignificantly = false

        pressTimer = setTimeout(() => {
          if (isWaitingForLongPress && !isLongPressTriggered && !hasMovedSignificantly) {
            isLongPressTriggered = true
            isWaitingForLongPress = false
            e.preventDefault()
            e.stopPropagation()

            // stop & prevent next clicks
            const preventClick = (clickEvent) => {
              clickEvent.preventDefault()
              clickEvent.stopPropagation()
              document.removeEventListener('click', preventClick, true)
            }
            document.addEventListener('click', preventClick, true)

            binding.value(e, el, { duration })
            cancelPress()
          }
        }, duration)
      }

      const onMouseMove = (e) => {
        if (!isWaitingForLongPress || isLongPressTriggered) return

        const currentX = getClientX(e)
        const currentY = getClientY(e)
        const moveX = Math.abs(currentX - startX)
        const moveY = Math.abs(currentY - startY)

        if (moveX > 10 || moveY > 10) {
          hasMovedSignificantly = true
          cancelPress()
        }
      }

      const onMouseUp = () => {
        cancelPress()
      }

      el.addEventListener('mousedown', onMouseDown)
      el.addEventListener('mousemove', onMouseMove)
      el.addEventListener('mouseup', onMouseUp)

      el._longPressHandlersMouse = {
        onMouseDown,
        onMouseMove,
        onMouseUp
      }
    }

    // add listener for stop open contextmenu, this run to all elements and document
    el.addEventListener('contextmenu', onContextMenu)
    el.addEventListener('selectstart', onSelectStart)
    el.addEventListener('copy', onCopy)

    // also prevent to target document if touch is on the current element
    const onDocumentContextMenu = (e) => {
      if (el.contains(e.target)) {
        e.preventDefault()
        e.stopPropagation()
        return false
      }
    }
    document.addEventListener('contextmenu', onDocumentContextMenu)

    // save for unbind
    el._longPressHandlers = {
      isTouchDevice,
      onTouchStart,
      onTouchMove,
      onTouchEnd,
      onTouchCancel,
      onContextMenu,
      onDocumentContextMenu,
      onSelectStart,
      onCopy,
      // ذخیره استایل‌های اصلی برای برگرداندن
      originalUserSelect,
      originalWebkitUserSelect,
      originalWebkitTouchCallout
    }
  },

  unbind (el) {
    if (el._longPressHandlers) {
      const h = el._longPressHandlers
      if (h.isTouchDevice) {
        el.removeEventListener('touchstart', h.onTouchStart)
        el.removeEventListener('touchmove', h.onTouchMove)
        el.removeEventListener('touchend', h.onTouchEnd)
        el.removeEventListener('touchcancel', h.onTouchCancel)
      }
      el.removeEventListener('contextmenu', h.onContextMenu)
      el.removeEventListener('selectstart', h.onSelectStart)
      el.removeEventListener('copy', h.onCopy)
      el.style.userSelect = h.originalUserSelect || ''
      el.style.webkitUserSelect = h.originalWebkitUserSelect || ''
      el.style.webkitTouchCallout = h.originalWebkitTouchCallout || ''
      document.removeEventListener('contextmenu', h.onDocumentContextMenu)
      delete el._longPressHandlers
    }

    if (el._longPressHandlersMouse) {
      const hm = el._longPressHandlersMouse
      el.removeEventListener('mousedown', hm.onMouseDown)
      el.removeEventListener('mousemove', hm.onMouseMove)
      el.removeEventListener('mouseup', hm.onMouseUp)
      delete el._longPressHandlersMouse
    }
  }
})
